// Values match the BE C# enum member names — that's what JsonStringEnumConverter
// emits on the wire, so the FE can compare/round-trip without translation.
// Who placed an order; Invoice / DailyRefill / ManualRefill are the automatic sources.
export enum UsafOrderSource {
  // Placed by a person on the Order Tires page
  Jarvis = 'Jarvis',
  // Imported from the USAF API (phone/website order placed outside the platform)
  Usaf = 'Usaf',
  // Sale-replacement placed by invoice sync
  Invoice = 'Invoice',
  // Placed by the 4 PM Daily Refill cron
  DailyRefill = 'DailyRefill',
  // Placed by a person from the Refill All page
  ManualRefill = 'ManualRefill'
}
